import { IQuestionType } from "../surveyTypes";

const questionTypeReducer = (data: any): IQuestionType => {
  return {
    instructions: data.instructions,
    inputType: data.input_type,
    minValue: data.min_value,
    maxValue: data.max_value,
    step: data.step,
    keys: data.key.split(","),
  };
};

export default questionTypeReducer;
